export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10968.2c9d95e4.jpg";